<template>
  <div>
    <div ref="div1" class="container">
      <div class="meet-level trans">
        <meet-header
          style="position: fixed; left: 0px; z-index: 2008"
          :headerConfig="headerConfig"
          @handleClickIocn="handleClickIocn"
        />

        <div class="main" style="height:85%;position: fixed; left: 0px; z-index: 2008">
          <h2 class="tit">会议日程</h2>
          <RichHtml style="height:100%;overflow: auto;margin:4px;" :content="content"></RichHtml>
        </div>
      </div>
    </div>
    <!-- <div id="image" style="margin-top:50px">
        <img src="@/assets/img/agenda.png" alt="" class="agendaimage"/>
    </div> -->
  </div>
</template>

<script>
  import meetHeader from "@/components/header"
  import CurrentConferMixin from "@/mixin/CurrentConference"
  import RichHtml from "@/components/RichHtml"

  export default {
    name: "meetLevel",
    components: {
      meetHeader,
      RichHtml
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "会议概况信息",
        },
        content: "",
      }
    },
    async mounted() {
    //   for (const item of this.$route.params.noticelist) {
    //     if (item.device == "手机") {
    //       this.scheduleList.push(item)
    //     }
    //   }
      await this.$store.dispatch('conference/getCurrentConference')
      const schedule = this.currentConference.schedules.find(
        (x) => x.device == "手机"
      )
      this.content = schedule.introduction
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
      handleDetails(item) {
        this.$router.push({
          name: "scheduledetail",
          params: { schedule: item },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .agendaimage {
    transform: rotate(0deg);
  }

  .main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 18px;
      font-weight: bold;
      color: var(--main-color);
    }

    .meet-notice-list {
      width: 100%;
      margin-top: 30px;

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        height: 30px;
        border-radius: 5px;
        margin-bottom: 15px;

        &:last-child {
          margin-bottom: 0;
        }

        .notice-tit {
          font-size: 14px;
        }

        .time {
          font-size: 12px;
        }
      }
    }
  }
</style>
